import type { Home, Platform } from './state';
export interface LadyBonus { platformId: string; offset: number; active: boolean }
export function updateHomes(homes: Home[], frame: number, level: number): void {
  const phase = frame % 720;
  const cycle = Math.floor(frame/720);
  const free = homes.map((h,i)=>h.occupied ? -1 : i).filter(i=>i>=0);
  for (const h of homes) {h.fly=false;h.crocodile=false;}
  if (!free.length) return;
  const fly = free[(cycle*3+level)%free.length]!;
  if (phase>=120 && phase<360) homes[fly]!.fly=true;
  if (level>=2 && phase>=400 && phase<610) {
    const i=free[(cycle+level+1)%free.length]!; homes[i]!.crocodile=true;
  }
}
export function ladyPosition(lady: LadyBonus | null, platforms: Platform[]): {x:number;y:number} | null {
  if (!lady?.active) return null;
  const p=platforms.find(p=>p.id===lady.platformId);
  return p ? {x:p.x+lady.offset,y:p.y} : null;
}
